import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Achievement = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex gap-20"
    >
      <div>
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2022 - 2024</p>
          <h2 className="text-4xl font-bold">Badges and Certificates</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="NITDA Front-end Development Associate"
            subTitle="A badge received for completing 5 course on Coursera platform"
            result="Badge"
            des="The courses covered incude Developing Interpersonal skills, Introduction to frontend development, version control and HTML and CSS in depth."
          />
          <ResumeCard
            title="Engausa Global Tech Hub"
            subTitle="A hub located at Kano State where skills are been learned"
            result="Certificate"
            des="It was a training received on basic building installation skills, the skills ranges from cctv camera installation, computer networking and intercom."
          />
          <ResumeCard
            title="National Animal Production Research Institute"
            subTitle="A research institute created by the Federal Government of Nigeria"
            result="Certificate"
            des="Training was received by me from various department of the institution ranging from artificial insemination department to animals health department."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Achievement;
